import React from 'react'
import PropTypes from 'prop-types'
import { default as dayjs } from 'dayjs'
import _ from 'lodash'
import DateRangePicker from 'react-bootstrap-daterangepicker'

import { useGetMutateCall } from '../../lib/api/get'
import { NoDataCard } from '../../common/NoDataCard'
import { useGetQuery } from '../../lib/api/get'
import { EditCAModal } from './EditCAModal'

import 'bootstrap-daterangepicker/daterangepicker.css'
import { AttendanceAudit } from './AttendanceAudit'

export const ChildAttendanceReport = ({ routeData, isLocalEnvironment, authDetails }) => {
  const clsRms = sessionStorage.getItem('auth')
    ? JSON.parse(sessionStorage.getItem('auth')).state
    : null
  const [reportData, setReportData] = React.useState(null)
  const [auditModal, setAuditModal] = React.useState(false)
  const [auditData, setAuditData] = React.useState(null)
  const [reportDataAfterFilter, setReportDataAfterFilter] = React.useState(null)
  const getCallMutation = useGetMutateCall()

  const [roomVal, setRoomVal] = React.useState(null)
  const [selectedDates, setSelectedDates] = React.useState(null)
  const [selectRoom, setSelectRoom] = React.useState(false)
  const [editEntry, setEditEntry] = React.useState(false)
  const [editEntryData, setEditEntryData] = React.useState(null)

  const getData = useGetQuery({
    apiURL: isLocalEnvironment + '/getData',
    apiEndpoint: 'staffClassRoom',
    params: '',
    isDynamic: true,
  })

  const handleCallback = (start, end) => {
    setSelectedDates({
      start: dayjs(start._d).format('YYYY-MM-DD'),
      end: dayjs(end._d).format('YYYY-MM-DD'),
    })
  }

  const editAttendance = (d) => {
    setEditEntryData(d)
    setEditEntry(true)
  }

  const closeEdit = () => {
    setEditEntryData(null)
    setEditEntry(false)
  }

  const auditReport = (d) => {
    setAuditData(d)
    setAuditModal(true)
  }

  const auditReportClose = () => {
    setAuditData(null)
    setAuditModal(false)
  }

  const onSearch = async (e) => {
    e.preventDefault()

    let rVal = ''
    if (roomVal !== null && roomVal !== '') {
      rVal = '&classRoomId=' + roomVal
    } else {
      setSelectRoom(true)
      return
    }

    await getCallMutation
      .mutateAsync({
        apiURL: isLocalEnvironment + '/getData',
        apiEndpoint: 'attendance',
        params:
          '&checkInDateTimeFrom=' +
          dayjs(selectedDates.start).format('YYYY-MM-DD 00:00:00') +
          '&checkInDateTimeTo=' +
          dayjs(selectedDates.end).format('YYYY-MM-DD 23:59:59') +
          rVal,
        isDynamic: true,
      })
      .then((resp) => {
        const dataRes = []
        resp.formData.length > 0 &&
          resp.formData.map((r) => {
            const elem = r
            elem['studentName'] = r.attendanceRegistration.studentName
            dataRes.push(elem)
          })
        const response = _.groupBy(dataRes, 'studentName')
        const entries = []
        Object.entries(response).map((m) => {
          const isAttendance = { studentName: m[0], attendance: m[1] }
          entries.push(isAttendance)
        })
        setReportData(entries)
      })
  }

  const filterByName = (e) => {
    if (reportDataAfterFilter === null) {
      setReportDataAfterFilter(reportData)
    }
    if (e.target.value === '') {
      if (reportDataAfterFilter !== null) {
        setReportData(reportDataAfterFilter)
        setReportDataAfterFilter(null)
      } else {
        const filterData = reportData.filter((f) => f.studentName === e.target.value)
        setReportData(filterData)
      }
    } else {
      const filterData = reportData.filter((f) => f.studentName === e.target.value)
      setReportData(filterData)
    }
  }

  const isLayoutDark = sessionStorage.getItem('themeLayout')
    ? sessionStorage.getItem('themeLayout')
    : false
  return (
    <React.Fragment key={isLayoutDark}>
      <div className="trtui-row">
        <div className="trtui-col-12">
          <div className="trtui-page-title-box trtui-d-sm-flex trtui-align-items-center trtui-justify-content-between">
            <h4 className="trtui-mb-sm-0">{routeData.pageTitle}</h4>
          </div>
        </div>
      </div>
      <div className="trtui-card-body">
        <form
          onSubmit={(e) => onSearch(e)}
          id="searchForm"
          className="trtui-page-title-box trtui-d-sm-flex trtui-align-items-center trtui-justify-content-between"
        >
          <div className="trtui-row">
            <div key="room" className="trtui-col-md-5 trtui-has-validation">
              <label>Class Room</label>
              <select
                className={`trtui-form-control trtui-mb-2 ${selectRoom && 'trtui-is-invalid'}`}
                style={{
                  paddingRight: 'calc(1.5em + 1rem)',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                  backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
                }}
                onChange={(e) => setRoomVal(e.target.value)}
              >
                <option value={''}>Select Room</option>
                {getData.data?.formData?.length > 0
                  ? getData.data?.formData?.map((r, rInd) => (
                      <option key={rInd} value={r.classRoomId}>
                        {r.staffClass.classRoomName}
                      </option>
                    ))
                  : (authDetails.orgRole === 'Staff Admin' ||
                        authDetails.orgRole === 'Office Staff') &&
                      clsRms !== null &&
                      clsRms.dependeciesFormAPIS?.classRoom?.formData.length > 0
                    ? clsRms.dependeciesFormAPIS?.classRoom?.formData.map((r, rInd) => (
                        <option key={rInd} value={r.classRoomId}>
                          {r.classRoomName}
                        </option>
                      ))
                    : null}
              </select>
              {selectRoom && <div className="trtui-invalid-feedback">Select Room</div>}
            </div>
            <div key="fromDate" className="trtui-col-md-5">
              <label>Date Range</label>
              <DateRangePicker onCallback={handleCallback}>
                <input className="trtui-form-control" />
              </DateRangePicker>
              {/* <label>From</label>
              <input type="date" name="fromDate" className="trtui-form-control" /> */}
            </div>
            {/* <div key="toDate" className="trtui-col-md-3">
              <label>To</label>
              <input type="date" name="toDate" className="trtui-form-control" />
            </div> */}
            <div className="trtui-col-md-2" style={{ paddingTop: '1.7rem' }}>
              <button
                className="trtui-btn trtui-btn-icon trtui-btn-primary"
                disabled={getCallMutation.isLoading}
              >
                {getCallMutation.isLoading ? (
                  <span className="trtui-d-flex trtui-align-items-center">
                    <span className="trtui-flex-grow-1 trtui-me-2"> </span>
                    <span className="trtui-spinner-border trtui-flex-shrink-0" role="status">
                      <span className="trtui-visually-hidden"> </span>
                    </span>
                  </span>
                ) : (
                  <i className="ri-search-line" />
                )}
              </button>
            </div>
          </div>
          <div>
            <label>Filter By</label>
            <select className="trtui-form-control" onChange={(e) => filterByName(e)}>
              <option value="">Show All</option>
              {reportData !== null &&
                reportData.length > 0 &&
                reportData.map((f, fInd) => (
                  <option key={fInd} value={f.studentName}>
                    {f.studentName}
                  </option>
                ))}
            </select>
          </div>
        </form>
      </div>
      {getCallMutation.isLoading ? (
        <div>
          <div
            id="status"
            className="trtui-align-items-center trtui-d-none trtui-d-md-block trtui-justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              position: 'absolute',
              left: '50%',
              top: '50%',
              margin: '-20px 0 0 6.4rem',
            }}
          >
            <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
              <span className="trtui-visually-hidden">Loading...</span>
            </div>
          </div>
          <div
            id="status"
            className="trtui-align-items-center trtui-d-block trtui-d-md-none trtui-justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              position: 'absolute',
              left: '20%',
              top: '50%',
              margin: '-20px 0 0 6.4rem',
            }}
          >
            <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
              <span className="trtui-visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div key={reportData} className="trtui-row trtui-justify-content-center">
          <div className="trtui-col-12">
            <div className="trtui-card trtui-p-1" style={{ overflowX: 'scroll' }}>
              {reportData !== null && reportData.length > 0 ? (
                reportData
                  .sort((a, b) => a.studentName - b.studentName)
                  .map((rep, repInd) => (
                    <>
                      <div key={repInd} className="trtui-table-responsive trtui-mt-4 trtui-mt-xl-0">
                        <table className="trtui-table trtui-table-hover trtui-table-striped trtui-align-middle trtui-table-nowrap trtui-mb-0">
                          <thead>
                            <tr>
                              <td
                                colSpan={4}
                                className="trtui-text-center trtui-pt-3 trtui-pb-3 trtui-fw-semibold"
                              >
                                {rep.studentName}
                              </td>
                            </tr>
                            <tr>
                              <th scope="col">Date</th>
                              <th scope="col">Check-In</th>
                              <th scope="col">Check-Out</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {rep.attendance.length > 0 &&
                              rep.attendance
                                .sort(
                                  (a, b) =>
                                    new Date(...a.checkInDateTime.split('/').reverse()) -
                                    new Date(...b.checkInDateTime.split('/').reverse()),
                                )
                                .map((d, dInd) => (
                                  <tr key={dInd}>
                                    <td className="trtui-fw-medium">
                                      {dayjs(d.checkInDateTime).format('YYYY-MM-DD')}
                                    </td>
                                    <td>{dayjs(d.checkInDateTime).format('HH:mm A')}</td>
                                    <td>{dayjs(d.checkOutDateTime).format('HH:mm A')}</td>
                                    <td>
                                      <i
                                        onClick={() => editAttendance(d)}
                                        title="Edit Attendance"
                                        className="ri-edit-line trtui-text-primary trtui-fs-17 trtui-lh-1 trtui-align-middle trtui-cursor-pointer"
                                      ></i>{' '}
                                      <i
                                        onClick={() => auditReport(d)}
                                        className="ri-history-line trtui-text-info trtui-fs-17 trtui-lh-1 trtui-align-middle trtui-cursor-pointer"
                                        title="History"
                                      ></i>
                                    </td>
                                  </tr>
                                ))}
                          </tbody>
                        </table>
                      </div>
                      {editEntry && (
                        <EditCAModal
                          isLocalEnvironment={isLocalEnvironment}
                          setOpenManage={closeEdit}
                          defaultData={editEntryData}
                          dataId="attendanceId"
                        />
                      )}
                      {auditModal && (
                        <AttendanceAudit
                          auditData={auditData}
                          auditReportClose={auditReportClose}
                          isLocalEnvironment={isLocalEnvironment}
                        />
                      )}
                    </>
                  ))
              ) : (
                <NoDataCard />
              )}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  )
}

ChildAttendanceReport.propTypes = {
  routeData: PropTypes.object,
  isLocalEnvironment: PropTypes.string,
  authDetails: PropTypes.object,
}
